(function () {
  let testimonialsLoaded = false;

  const starSvgFull =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="w-5 h-5 inline-block mr-0.5" aria-hidden="true"><path d="M9.23893 0.873855C9.48346 0.37847 9.60572 0.130778 9.7717 0.0516404C9.91611 -0.0172135 10.0839 -0.0172135 10.2283 0.0516404C10.3943 0.130778 10.5165 0.37847 10.7611 0.873854L13.081 5.57369C13.1531 5.71994 13.1892 5.79306 13.242 5.84984C13.2887 5.9001 13.3447 5.94083 13.4069 5.96977C13.4772 6.00245 13.5579 6.01424 13.7193 6.03783L18.9085 6.79631C19.455 6.87618 19.7282 6.91612 19.8546 7.04959C19.9646 7.16571 20.0164 7.32528 19.9954 7.48386C19.9714 7.66613 19.7736 7.8588 19.3779 8.24412L15.6244 11.9001C15.5074 12.0141 15.4489 12.071 15.4111 12.1388C15.3777 12.1989 15.3563 12.2648 15.348 12.333C15.3386 12.4101 15.3524 12.4906 15.3801 12.6516L16.2657 17.8154C16.3591 18.3601 16.4058 18.6324 16.3181 18.794C16.2417 18.9346 16.1059 19.0332 15.9486 19.0624C15.7678 19.0959 15.5232 18.9673 15.0342 18.7101L10.395 16.2704C10.2505 16.1944 10.1782 16.1564 10.1021 16.1415C10.0347 16.1283 9.96533 16.1283 9.89791 16.1415C9.82177 16.1564 9.7495 16.1944 9.60496 16.2704L4.96584 18.7101C4.47675 18.9673 4.23221 19.0959 4.05138 19.0624C3.89406 19.0332 3.75831 18.9346 3.68194 18.794C3.59416 18.6324 3.64087 18.3601 3.73428 17.8154L4.61995 12.6516C4.64756 12.4906 4.66136 12.4101 4.65202 12.333C4.64375 12.2648 4.62231 12.1989 4.58888 12.1388C4.55113 12.071 4.49263 12.0141 4.37562 11.9001L0.622059 8.24412C0.226447 7.8588 0.0286405 7.66613 0.00456994 7.48386C-0.0163728 7.32528 0.0353655 7.16571 0.14538 7.04959C0.271825 6.91612 0.545049 6.87618 1.0915 6.79631L6.28073 6.03783C6.44211 6.01424 6.5228 6.00245 6.59307 5.96977C6.65529 5.94083 6.71131 5.9001 6.75801 5.84984C6.81076 5.79306 6.84686 5.71994 6.91905 5.57369L9.23893 0.873855Z" fill="#FFB4C6"/></svg>';
  const starSvgEmpty =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="w-5 h-5 inline-block mr-0.5 opacity-30" aria-hidden="true"><path d="M9.23893 0.873855C9.48346 0.37847 9.60572 0.130778 9.7717 0.0516404C9.91611 -0.0172135 10.0839 -0.0172135 10.2283 0.0516404C10.3943 0.130778 10.5165 0.37847 10.7611 0.873854L13.081 5.57369C13.1531 5.71994 13.1892 5.79306 13.242 5.84984C13.2887 5.9001 13.3447 5.94083 13.4069 5.96977C13.4772 6.00245 13.5579 6.01424 13.7193 6.03783L18.9085 6.79631C19.455 6.87618 19.7282 6.91612 19.8546 7.04959C19.9646 7.16571 20.0164 7.32528 19.9954 7.48386C19.9714 7.66613 19.7736 7.8588 19.3779 8.24412L15.6244 11.9001C15.5074 12.0141 15.4489 12.071 15.4111 12.1388C15.3777 12.1989 15.3563 12.2648 15.348 12.333C15.3386 12.4101 15.3524 12.4906 15.3801 12.6516L16.2657 17.8154C16.3591 18.3601 16.4058 18.6324 16.3181 18.794C16.2417 18.9346 16.1059 19.0332 15.9486 19.0624C15.7678 19.0959 15.5232 18.9673 15.0342 18.7101L10.395 16.2704C10.2505 16.1944 10.1782 16.1564 10.1021 16.1415C10.0347 16.1283 9.96533 16.1283 9.89791 16.1415C9.82177 16.1564 9.7495 16.1944 9.60496 16.2704L4.96584 18.7101C4.47675 18.9673 4.23221 19.0959 4.05138 19.0624C3.89406 19.0332 3.75831 18.9346 3.68194 18.794C3.59416 18.6324 3.64087 18.3601 3.73428 17.8154L4.61995 12.6516C4.64756 12.4906 4.66136 12.4101 4.65202 12.333C4.64375 12.2648 4.62231 12.1989 4.58888 12.1388C4.55113 12.071 4.49263 12.0141 4.37562 11.9001L0.622059 8.24412C0.226447 7.8588 0.0286405 7.66613 0.00456994 7.48386C-0.0163728 7.32528 0.0353655 7.16571 0.14538 7.04959C0.271825 6.91612 0.545049 6.87618 1.0915 6.79631L6.28073 6.03783C6.44211 6.01424 6.5228 6.00245 6.59307 5.96977C6.65529 5.94083 6.71131 5.9001 6.75801 5.84984C6.81076 5.79306 6.84686 5.71994 6.91905 5.57369L9.23893 0.873855Z" fill="#FFB4C6"/></svg>';

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getStarHtml(score) {
    const rating = Math.max(0, Math.min(5, Number(score) || 0));
    return starSvgFull.repeat(rating) + starSvgEmpty.repeat(5 - rating);
  }

  function getReviewImageUrl(review) {
    const media = review.media;
    if (!media?.length) return null;

    const image = media.find((item) => item.type === 'image' && !item.isHidden) || media[0];
    return image?.largeUrl || image?.thumbnailUrl || image?.fullSizeUrl || null;
  }

  function getFiveStarCount(aggregateData) {
    const aggregate = aggregateData?.reviewAggregate;
    if (!aggregate) return null;

    const fiveStarCount =
      aggregate.reviewCountByLevel?.level5Count ??
      aggregate.ratingAndReviewCountByLevel?.level5Count;

    if (fiveStarCount != null) return Number(fiveStarCount);
    if (aggregate.reviewCount != null) return Number(aggregate.reviewCount);

    return null;
  }

  function reloadReviews(reviews, sliderRoot) {
    const reviewContainer = sliderRoot.querySelector('.swiper-wrapper');
    if (!reviewContainer) return;

    reviewContainer.innerHTML = '';

    reviews.slice(0, 9).forEach((review) => {
      const imageUrl = getReviewImageUrl(review);
      if (!imageUrl) return;

      const displayName = review.reviewer?.displayName || review.reviewer?.name || 'Customer';
      const title = review.title || '';
      const body = review.body || '';
      const rating = review.rating || 0;
      const dateLabel = review.dateCreated
        ? new Date(review.dateCreated).toLocaleDateString()
        : '';

      const testimonial = document.createElement('div');
      testimonial.className = 'px-0 swiper-slide';
      testimonial.innerHTML = `
        <div class="bg-transparent text-[#0E0E0E]">
          <div class="w-full aspect-[238/334] overflow-hidden mb-[20px]">
            <img src="${escapeHtml(imageUrl)}" alt="Review by ${escapeHtml(displayName)}" class="w-full h-full object-cover" width="238" height="334" loading="lazy">
          </div>
          <div class="font-medium text-[20px] mb-[12px]">${escapeHtml(title)}</div>
          <div class="mb-[12px] overflow-hidden text-ellipsis line-clamp-3 text-[12px] leading-normal tracking-[0.12px]">${escapeHtml(body)}</div>
          <div class="flex mb-[12px]">${getStarHtml(rating)}</div>
          <div class="font-normal mb-[12px] text-[12px] leading-normal tracking-[0.12px]">${escapeHtml(displayName)}</div>
          <div class="font-normal text-[12px] leading-normal tracking-[0.12px]">${escapeHtml(dateLabel)}</div>
        </div>
      `;
      reviewContainer.appendChild(testimonial);
    });

    initializeTestimonialSwiper(sliderRoot);
  }

  function initializeTestimonialSwiper(testimonials) {
    if (!testimonials || typeof Swiper === 'undefined') return;

    const swiper = new Swiper(testimonials, {
      pagination: {
        el: testimonials.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          const strings = window.accessibilityStrings || {};
          const loadSlide = strings.loadSlide || 'Go to slide';
          const of = strings.sliderOf || 'of';
          const total = testimonials.querySelectorAll('.swiper-slide').length;
          return `<button type="button" class="${className}" aria-label="${loadSlide} ${index + 1} ${of} ${total}"></button>`;
        },
      },
      slidesPerView: window.innerWidth > 768 ? 4.5 : 1.5,
      spaceBetween: 20,
      grabCursor: true,
      loop: true,
    });

    function syncPaginationAriaCurrent(swiperInstance) {
      const paginationEl = swiperInstance.pagination?.el;
      if (!paginationEl) return;
      const index =
        typeof swiperInstance.realIndex === 'number'
          ? swiperInstance.realIndex
          : swiperInstance.activeIndex;
      paginationEl.querySelectorAll('button.swiper-pagination-bullet').forEach(function (btn, i) {
        if (i === index) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    }

    swiper.on('slideChange', function () {
      syncPaginationAriaCurrent(swiper);
    });
    syncPaginationAriaCurrent(swiper);

    let swiperResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(swiperResizeTimer);
      swiperResizeTimer = setTimeout(function () {
        swiper.params.slidesPerView = window.innerWidth > 768 ? 3.5 : 1.5;
        swiper.update();
      }, 200);
    });
  }

  async function loadOkendoData(sliderRoot) {
    if (testimonialsLoaded) return;

    const okendoUserId = sliderRoot.dataset.okendoUserId;
    if (!okendoUserId) return;

    testimonialsLoaded = true;

    const apiBase = `https://api.okendo.io/v1/stores/${encodeURIComponent(okendoUserId)}`;
    const reviewCountElement = document.querySelector('.index-testimonials__count');

    try {
      const [reviewsRes, aggregateRes] = await Promise.all([
        fetch(`${apiBase}/reviews?limit=25&orderBy=${encodeURIComponent('has_media desc')}`),
        fetch(`${apiBase}/review_aggregate`),
      ]);

      if (reviewsRes.ok) {
        const reviewsData = await reviewsRes.json();
        const picturedFiveStar = (reviewsData.reviews || []).filter(
          (review) => review.rating === 5 && review.media?.length
        );
        reloadReviews(picturedFiveStar, sliderRoot);
      }

      if (aggregateRes.ok && reviewCountElement) {
        const aggregateData = await aggregateRes.json();
        const total = getFiveStarCount(aggregateData);
        if (total) {
          reviewCountElement.textContent = `Over ${total.toLocaleString('en-US')} 5-Star Reviews From Our Happy Customers`;
        }
      }
    } catch (error) {
      console.error('Okendo reviews error:', error);
    }
  }

  function init() {
    const sliderRoot = document.querySelector('[data-testimonials]');
    if (!sliderRoot) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            observer.disconnect();
            loadOkendoData(sliderRoot);
          }
        },
        { rootMargin: '200px' }
      );
      observer.observe(sliderRoot);
    } else {
      loadOkendoData(sliderRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
